export default {
  documentsPrintingList: [],
  documentPrinting: new FormData(),
}
